let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("esVy5")).then(() => parcelRequire('bjFeZ'));